/* eslint-disable ember/no-computed-properties-in-native-classes */
import Controller from '@ember/controller';
import { computed } from '@ember/object';

export default class QuickCommentsController extends Controller {
  @computed('model.pages.@each.{sequence,label}')
  get pages() {
    return this.model.pages
      .slice()
      .sort(
        (a, b) =>
          a.sequence - b.sequence ||
          (a.label || '').localeCompare(b.label || ''),
      );
  }
}
